import {asREM} from '@raison/ui-kit';
import React, {Component} from 'react';
import styles from './Elements.module.scss';

export class RightArrow extends Component {
    render() {
        return (
            <svg
                version='1.1'
                xmlns='http://www.w3.org/2000/svg'
                xmlnsXlink='http://www.w3.org/1999/xlink'
                x='0px'
                y='0px'
                width={this.props.width ? this.props.width : asREM(6.4)}
                height={this.props.height ? this.props.height : asREM(9.6)}
                viewBox='0 0 16.463 25.463'
                enableBackground='new 0 0 16.463 25.463'
                xmlSpace='preserve'
                className={styles.arrows}
            >
                <g>
                    <polygon
                        fill={this.props.color ? this.props.color : '#FFFFFF'}
                        points='16.463,12.713 3.713,0 0,3.713 9.019,12.731 0,21.75 3.713,25.463 	'
                    />
                </g>
            </svg>
        );
    }
}

export class Arrows extends Component {
    render() {
        return (
            <svg
                version='1.0'
                xmlns='http://www.w3.org/2000/svg'
                width='141px'
                height='67px'
                viewBox='0 0 282 134'
                className={styles.backgroundArrows}
                preserveAspectRatio='xMidYMid meet'
            >
                <g transform='translate(0.000000,134.000000) scale(0.100000,-0.100000)' fill='#15b0db' stroke='none'>
                    <path
                        d='M0 1317  c4 -8 136 -154 293 -327 157 -172 286 -316 288 -321 3 -6
                        -403 -459 -567 -631 l-35 -38 245 0 244 0 303 331 c167 181 302 334 300 339
                        -2 4 -137 155 -301 334 l-298 326 -240 0 c-197 0 -239 -2 -232 -13z'
                    />

                    <path
                        d='M887 1317 c4 -8 136 -154 293 -327 157 -172 286 -316 288 -321 3 -6
                        -403 -459 -567 -631 l-35 -38 245 0 244 0 303 331 c167 181 302 334 300 339
                        -2 4 -137 155 -301 334 l-298 326 -240 0 c-197 0 -239 -2 -232 -13z'
                    />

                    <path
                        d='M1737 1317 c4 -8 136 -154 293 -327 157 -172 286 -316 288 -321 3 -6
                        -403 -459 -567 -631 l-35 -38 245 0 244 0 303 331 c167 181 302 334 300 339
                        -2 4 -137 155 -301 334 l-298 326 -240 0 c-197 0 -239 -2 -232 -13z'
                    />
                </g>
            </svg>
        );
    }
}

export class DownArrow extends Component {
    render() {
        return <i className={styles.arrow_down} />;
    }
}

export class Refresh extends Component {
    render() {
        return <i className={this.props.active ? styles.refresh_active : styles.refresh} />;
    }
}

export class SmilePositive extends Component {
    render() {
        return <i className={styles.smile_positive} />;
    }
}

export class SmileNegative extends Component {
    render() {
        return <i className={styles.smile_negative} />;
    }
}

export class SmileNeutral extends Component {
    render() {
        return <i className={styles.smile_neutral} />;
    }
}

export class Filters extends Component {
    render() {
        return <i className={styles.filters} />;
    }
}
